

import { BitmapText } from "pixi.js";
import { Power3, gsap } from "gsap";
import { GameConfig } from "../config/base/GameConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { CurrencyOptions } from "@nolimitcity/slot-launcher/bin/interfaces/APICurrency";
import { Helper } from "../../dev/utils/Helper";
import { BitmapTextStyleOptions } from "../../dev/setting/text/IText";
import { ResizeHelper } from "../../dev/utils/ResizeHelper";

export interface ICountUpAnimationConfig {
    duration:number;
    ease?: any;
    onStart?:Function;
    onUpdate?:Function;
    onComplete?:Function;
}

export class BitmapCountUp extends BitmapText {

    private _currencyOption:CurrencyOptions | undefined;
    private _currentValue:number;

    private _maxTextWidth:number;
    private counterTl: gsap.core.Timeline;

    get maxTextWidth():number {
        return this._maxTextWidth;
    }

    set maxTextWidth(value:number) {
        this._maxTextWidth = value;
        if(this.parent) {
            this.updateCountUpTextPivot();
        } 
    }

    get currentValue():number {
        return this._currentValue;
    }

    set currentValue(value:number) {
        this._currentValue = value;
        this.onCountUpUpdate();
    }

    get scaling():number {
        return this.scale.x;
    }

    set scaling(value:number) {
        this.scale.set(value);
    }

    constructor(config:BitmapTextStyleOptions, currencyOption?:CurrencyOptions) {
        super("0", config);
        this._currencyOption = currencyOption;
    }

    public getCountUpAnimation(fromValue:number, toValue:number, animationConfig:ICountUpAnimationConfig ): gsap.core.Timeline {
        this.counterTl = Helper.setTimeline(this.counterTl, new  gsap.core.Timeline({
            onStart : () => Helper.triggerIfExist(animationConfig.onStart),
            onUpdate : () => Helper.triggerIfExist(animationConfig.onUpdate),
            onComplete:() => Helper.triggerIfExist(animationConfig.onComplete),
        }));
        this.counterTl.fromTo(this, { currentValue: fromValue, },
            {
                duration: animationConfig.duration,
                currentValue: toValue,
                ease: animationConfig.ease ? animationConfig.ease : Power3.easeInOut,
            }
        );
        return this.counterTl;
    }

    public setTextStyle(config:BitmapTextStyleOptions):boolean{

        if(this.fontName === config.fontName) return false;
        
        this.fontName = config.fontName;
        this.fontSize = config.fontSize;
        this.letterSpacing = config.letterSpacing!;

        return true;
    }

    public showValue(value:number, formate:boolean = true):void{
        this.currentValue = formate ? parseFloat(SlotGame.apiPlugin.currency.formatValue(value, this._currencyOption)) : value;
        this.text = formate ? SlotGame.apiPlugin.currency.formatValue(this.currentValue, this._currencyOption) : this.currentValue.toString()
        
        this.updateCountUpTextPivot();
    }

    private onCountUpUpdate():void {
        this.text = SlotGame.apiPlugin.currency.formatValue(this.currentValue, this._currencyOption);
        this.updateCountUpTextPivot();
    }

    public updateCountUpTextPivot():void {
        this.updateTransform();

        if(this.maxTextWidth == null || this.maxTextWidth <= 0) {
            this.maxTextWidth = ResizeHelper.isLandscape ? GameConfig.instance.BASE_DIM.landscape.WIDHT : GameConfig.instance.BASE_DIM.portrait.WIDHT;
        }

        while(this.textWidth * this.scaling > this.maxTextWidth) {
            this.scaling = this.scaling * 0.995;
            this.updateTransform();
        }
    }
}